import axios from 'axios';

const API_KEY = process.env.REACT_APP_GEOAPIFY_API_KEY;
const BASE_URL = process.env.REACT_APP_GEOAPIFY_BASE_URL;

// دالة لجلب اقتراحات الأماكن من Geoapify
export const fetchPlaceSuggestions = async (query, city = null, lang = 'en') => {
  try {
    // تحديد حدود البحث بناءً على المدينة المختارة
    let filter = 'place:51cff1d9c4b22c56c0590d6b9f3c2857'; // Cairo and Giza
    if (city) {
      filter = city === 'Cairo' ? 'place:51cff1d9c4b22c56c0590d6b9f3c2857' : 'place:51b0e8d7c8b22c56c0590d6b9f3c2857'; // Cairo or Giza
    }

    // إضافة فلتر الدولة عشان نضمن إن كل الاقتراحات تكون جوه مصر بس
    // ملحوظة: الفاصل بين فلترين مختلفين في Geoapify لازم يكون "|" مش ","
    filter = `${filter}|countrycode:eg`;

    const response = await axios.get(BASE_URL, {
      params: {
        text: query,
        apiKey: API_KEY,
        filter: filter,
        limit: 4, // تحديد 4 اقتراحات فقط
        lang: lang, // اللغة بتتحدد حسب لغة النص اللي المستخدم كاتبه
      },
    });

    // إرجاع النتايج لو موجودة، وإلا قائمة فاضية
    return response.data.features || [];
  } catch (error) {
    console.error('Error fetching place suggestions:', error);
    throw new Error('Please come back later');
  }
};